import { render, staticRenderFns } from "./NotTeams.vue?vue&type=template&id=29086cb0&scoped=true"
import script from "./NotTeams.vue?vue&type=script&lang=js"
export * from "./NotTeams.vue?vue&type=script&lang=js"
import style0 from "./NotTeams.vue?vue&type=style&index=0&id=29086cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29086cb0",
  null
  
)

export default component.exports